const tableHead = [{
    'key': 'ip_no',
    'text': 'IP number'
}, {
    'key': 'umr_no',
    'text': 'UMR number'
}, {
    'key': 'patient_name',
    'text': 'Patient Name'
}, {
    'key': 'phone_number',
    'text': 'Phone Number'
}, {
    'key': 'date_of_counselling',
    'text': 'date of counselling'
}, {
    'key': 'doctor_name',
    'text': 'Doctor Name'
}, {
    'key': 'department_name',
    'text': 'Department Name'
}, {
    'key': 'unit_name',
    'text': 'Unit Name'
},
{
    'key': 'rn_preauth_submitted',
    'text': 'Post-auth Submitted'
},
{
    'key': 'payer_reponse_remarks',
    'text': 'Insurance Status'
},
{
    'key': 'fc_payer_type',
    'text': 'FC Payer Type'
},
{
    'key': 'hims_payer_type',
    'text': 'HIMS Payer Type'
},
{
    'key': 'rn_preauth_requested_time',
    // 'text': 'Preauth Submission Date'
    'text': 'Post-Auth Triggered Time'
},
{
    'key': 'rn_preauth_submitted_date',
    'text': 'Post-Auth Requested Time'
}, {
    'key': 'payer_updated_at',
    'text': 'Post-Auth Response Received Date'
},
{
    'key': 'payer_approved_amount',
    'text': 'Approved Amount(Rs.)'
},
{
    'key': 'remedinet_remarks',
    'text': 'Remedinet Remarks'
},
// {
//     'key': 'approval_file_content',
//     'text': 'Document received from Remedinet'
// },
{
    'key': 'approval_file_name',
    'text': 'Document received from Remedinet'
},
{
    'key': 'is_lan_bill_prepared',
    'text': 'Lan Bill Prepared'
},
{
    'key': 'corp_approx_final_bill_status',
    'text': 'Crop Approx Final Bill Status'
},
{
    'key': 'discharge_summary_approval_status',
    'text': 'Discharge Summary Approval Status'
},
{
    'key': 'assigned_to',
    'text': 'Status'
},
{
    'key': 'action',
    'text': 'Action'
}

];

const  thead = [
    {
        'key': 'historyid',
        'text': 'History ID'
    },
    {
        'key': 'preauth_actionstatus',
        'text': 'Post-Auth Requested' 
    },
    {
        'key': 'preauth_submited_time',
        'text': 'Post-Auth Triggered Time' 
    },
    //  {
    //     'key': 'preauth_submited_time',
    //     'text': 'Post-Auth Requested Time' 
    // },
    {
        'key': 'payer_status',
        'text': 'Payer Status'
    },
    {
        'key': 'payer_updated_time',
        'text': 'Payer Updated Time'
    }, {
        'key': 'approvedamount',
        'text': 'Approved amount'
    }, {
        'key': 'approveddate',
        'text': 'Approved Time'
    }, {
        'key': 'remedinet_remarks',
        'text': 'Remedinet Remarks'
    }

];

export {tableHead,thead}